
const state = { 
	userInfo:'',
	token:''
};
const mutations= {
    setToken(state, data){
        state.token = data;
    },
    setUser(state, data){
        state.userInfo = data;
    }
};


export default {
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js